import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PageWrapper from '../../../../internal/PageWrapper'
import { getText } from '../../../../internal/TextLabels'
import { PayApplyType } from '../../../../models/payapply'
import styles from './styles.module.scss'
import {
  cancelSigning,
  getApplication,
  getPayment,
  getSigningStatus,
  pageHalt,
} from '../../../../store/actions/pay-apply-actions'
import { SigningTabs } from './UI/SigningTabs'

const getCurrentPaymentModel = ({
  current: { type: payApplyType },
  application,
  payment,
}) => {
  if (payApplyType === PayApplyType.PAYMENT) {
    return payment.paymentResult
  }
  return application.applicationResult
}

// eslint-disable-next-line react/prefer-stateless-function
class ApplicationSignPage extends Component {
  render() {
    const result = getCurrentPaymentModel(this.props.data)

    const titleText = result.payment
      ? result.application
        ? 'payApply.sign.titleSuccessApplicationPayment'
        : 'payApply.sign.titleSuccessPayment'
      : 'payApply.sign.titleSuccessApplication'
    return (
      <div style={{ marginBottom: '5rem' }}>
        <PageWrapper
          noPadding
          type="success"
          title={getText('payApply.sign.pageTitle')}
        >
          <div
            style={{
              display: 'relative',
              padding: '2rem',
            }}
          >
            <div style={{ display: 'flex' }}>
              <h6 style={{ margin: '1.2rem 0', fontWeight: 'normal' }}>
                {getText(titleText)}
              </h6>
            </div>
          </div>
        </PageWrapper>

        <PageWrapper noPadding>
          <div style={{ padding: '2rem' }} className={styles.signPage}>
            <SigningTabs
              paymentResult={result}
              onPageLoading={this.props.data.wizard.onPageLoading}
              isLoading={this.props.data.wizard.newPageLoading}
              onNext={this.props.onNext}
              authorities={this.props.authorities}
              onUpdateApplication={() =>
                this.props.updateApplication(result.id, true)
              }
              payApplyData={this.props.data}
              onCompleteSigning={this.props.updateSigningStatus}
              onPageHalt={this.props.onPageHalt}
              cancelSigning={() => this.props.cancelSigning(result.id)}
              isAutomaticDebitEnabled={this.props.automaticDebit}
              delayedPaymentEnabled={this.props.delayedPaymentEnabled}
            />
          </div>
        </PageWrapper>
      </div>
    )
  }
}

ApplicationSignPage.propTypes = {
  data: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  updateApplication: PropTypes.func.isRequired,
  updateSigningStatus: PropTypes.func.isRequired,
  authorities: PropTypes.array.isRequired,
  onPageHalt: PropTypes.func.isRequired,
  cancelSigning: PropTypes.func.isRequired,
  automaticDebit: PropTypes.bool.isRequired,
  delayedPaymentEnabled: PropTypes.bool.isRequired,
}

const mapStateToProps = state => ({
  authorities: state.auth.authorities,
  automaticDebit:
    state.payApply.payment.paymentResult?.publicSettings?.automaticDebit,
  delayedPaymentEnabled:
    state.storeInfo.currentRepresentative.delayedPaymentEnabled,
})

const mapDispatchToProps = (dispatch, { data: payApply }) => ({
  updateApplication: (id, onPageLoad) => {
    if (payApply.current.type === PayApplyType.PAYMENT) {
      dispatch(getPayment(id, onPageLoad))
    } else {
      dispatch(getApplication(id, onPageLoad))
    }
  },
  onPageHalt: () => {
    dispatch(pageHalt())
  },
  updateSigningStatus: () => {
    return dispatch(getSigningStatus)
  },
  cancelSigning: id => {
    dispatch(cancelSigning(id))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationSignPage)
